import React, { useState, useCallback, useEffect, useRef } from 'react';
import './Image_slider.css';
import PhotoImg  from '../../Aseets/Img/necklaceslider.png';
import SketchImg from '../../Aseets/Img/neclacesketch.png';

const ImageSlider = () => {
  const wrapperRef  = useRef(null);
  const dividerRef  = useRef(null);
  const handleRef   = useRef(null);
  const photoRef    = useRef(null);

  const [dragging, setDragging] = useState(false);

  const applyPos = useCallback((pct) => {
    const c = Math.min(1, Math.max(0, pct));
    if (dividerRef.current) dividerRef.current.style.left = `${c * 100}%`;
    if (handleRef.current)  handleRef.current.style.left  = `${c * 100}%`;
    if (photoRef.current)   photoRef.current.style.clipPath = `inset(0 ${(1 - c) * 100}% 0 0)`;
  }, []);

  const getPct = useCallback((clientX) => {
    const rect = wrapperRef.current.getBoundingClientRect();
    return (clientX - rect.left) / rect.width;
  }, []);

  const onPointerDown = useCallback((e) => {
    e.preventDefault();
    wrapperRef.current.setPointerCapture(e.pointerId);
    setDragging(true);
    applyPos(getPct(e.clientX));
  }, [applyPos, getPct]);

  const onPointerMove = useCallback((e) => {
    if (!dragging) return;
    applyPos(getPct(e.clientX));
  }, [dragging, applyPos, getPct]);

  const onPointerUp = useCallback((e) => {
    if (!dragging) return;
    setDragging(false);
  }, [dragging]);

  const onTouchMove = useCallback((e) => {
    e.preventDefault();
    applyPos(getPct(e.touches[0].clientX));
  }, [applyPos, getPct]);

  const onDoubleClick = useCallback(() => applyPos(0.5), [applyPos]);

  useEffect(() => { applyPos(0.5); }, [applyPos]);

  return (
    <div
      ref={wrapperRef}
      className={`image-slider-wrapper${dragging ? ' dragging' : ''}`}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerUp}
      onTouchMove={onTouchMove}
      onDoubleClick={onDoubleClick}
    >
      <span className="slider-corner slider-corner--tl" />
      <span className="slider-corner slider-corner--tr" />
      <span className="slider-corner slider-corner--bl" />
      <span className="slider-corner slider-corner--br" />

      <img className="slider-img slider-img--sketch" src={SketchImg} alt="" draggable={false} />
      <img ref={photoRef} className="slider-img slider-img--photo" src={PhotoImg} alt="" draggable={false} />

      <div ref={dividerRef} className="slider-divider" />

      <div ref={handleRef} className="slider-handle">
        <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
        <svg viewBox="0 0 24 24" style={{ transform: 'scaleX(-1)' }}><polyline points="15 18 9 12 15 6"/></svg>
      </div>
    </div>
  );
};

export default ImageSlider;